/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// get the main domain to store the cookie. otherwise we can't share the cookie between subdomains
function extractDomain(host) {
    const parts = host.split(".");
    if (parts.length > 2) {
        parts.shift();
    }
    return parts.join(".");
}

// Main code in an async IIFE -EKL
(async () => {
  let savedCart = {
    item_count: 0
  }
  
  async function updateCartCountCookie(count = -1) {
    if (count === -1) {
      const request = await window.fetch('/cart.json')
      const cart = await request.json()

      savedCart = cart
    }
      
    const myDate = new Date();
    myDate.setMonth(myDate.getMonth() + 1);
      
    document.cookie = `AScartCounter=${savedCart.item_count.toString()};expires=${myDate};domain=.${extractDomain(location.hostname)};path=/`;
  }
  
  function updateCartIcon() {
    const icon = document.querySelector('.as-menu-bar__icon[data-name="cart"]');
    const title = icon?.parentNode?.querySelector('.as-menu-bar__button-title') || null;
  
    if (!icon || !title) {
      return;
    }
  
    title.innerText = savedCart.item_count.toString();
    title.style = savedCart.item_count ? '' : 'clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute;'

    icon.parentNode.classList.toggle('as-menu-bar__button--cart-has-value', !!savedCart.item_count);
  }
  
  function saveUserLoginState() {
    // save client id in cookie for this browser session so no expiry needed
    document.cookie = `ASUserLoggedInId=${__st.cid ? __st.cid : ' '};domain=.${extractDomain(location.hostname)};path=/`;
  }
  
  document.addEventListener('bundler:total_cart_values', function(event) {
    if (!event.detail) {
      return
    }
    
    const span = document.querySelector('.cart__total-container .h6 span')

    // NOTE: the event.detail values are always in cents, not in dollars, therefore you have to divide them by 100 to get dollars.
    if (span && event.detail.discount_amount > 0) {
      span.innerHTML = 'Normal price<br/>Your discount<br/>Total'      
    }
  });
  
  // Get the updated content of the cart, maybe this can be without api call
  // NOTE: This one doesnt seem to get fired.
  document.addEventListener('cart:updated', function(event) {
    if (!event.detail || !event.detail.cart) {
      return
    }

    savedCart = event.detail.cart;
    
    updateCartCountCookie(savedCart.item_count);
    updateCartIcon();
  });
  
  // update cart on initial load
  document.addEventListener('DOMContentLoaded', () => {
    updateCartIcon();
    updateCartCountCookie();
    saveUserLoginState();
  })
  
  async function setDeviceTabData() {
    let devicehandle = document.getElementById('pdp-device-tab')?.dataset?.device;

    if (!devicehandle) {
      return
    }

    const tab = document.getElementById('pdp-device-tab')

    if (!tab) {
      return
    }
    
    const request = await window.fetch('https://ambleandstrut.com/wapi/v2/devicetab/?devicedata='+devicehandle)
    const devicedata = await request.json()

    document.getElementById('pdp-device-tab').innerHTML = devicedata.devices?.name || '';
  }

  async function setDeviceLabelData() {
    let devicehandle = document.getElementById('pdp-device-tab')?.dataset?.device;

    if (!devicehandle) {
      return
    }

    const tab = document.getElementById('pdp-label-container')

    if (!tab) {
      return
    }
    
    const request = await window.fetch('https://ambleandstrut.com/wapi/v2/devicelabels/?devicedata='+devicehandle)
    const devicedata = await request.json()

    document.getElementById('pdp-label-container').innerHTML = devicedata.labels?.content || '';
  }  
  
  // update on initial load
  document.addEventListener('DOMContentLoaded', () => {
    setDeviceLabelData();
    setDeviceTabData();
  })
  
  async function loadFooter() {
    const response = await fetch('https://ambleandstrut.com/wapi/v2/footer/', { mode: 'cors', credentials: 'same-origin' });
    const html = await response.text();
    const footerContainer = document.querySelector('.shopify-section--footer');
  
    if (html && footerContainer) {
      try {
        footerContainer.innerHTML = html
      } catch(e) {
        console.warn(e);
      }
    }
  }
  
  async function loadMainNavigation() {
    // Cookies are not being send through from Shopify due to CORS policy. Including SameSite=None;Secure;HttpOnly; in the cookie header has not resolved the issue. 
    // The workaround of including the cookies in the params works for now. - JVL
    const ASUserLoggedInId = document.cookie
      .split("; ")
      .find((row) => row.startsWith("ASUserLoggedInId="))
      ?.split("=")[1];
    const AScartCounter = document.cookie
      .split("; ")
      .find((row) => row.startsWith("AScartCounter="))
      ?.split("=")[1];
    const userLoggedIn = ASUserLoggedInId !== ''
    const response = await fetch(`https://ambleandstrut.com/wapi/v2/menu/?loggedin=${userLoggedIn}&cartcount=${AScartCounter}`, { mode: 'cors', credentials: 'same-origin' });
    const html = await response.text();
    const menuContainer = document.querySelector('.shopify-section--header');

    if (html && menuContainer) {
      try {
        menuContainer.innerHTML = html;
        document.documentElement.style.setProperty('--header-height', '3.75rem');
        initializeMainMenu();
        updateCartIcon();
      } catch(e) {
        console.warn(e);
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    loadMainNavigation();
    loadFooter();
  });
  
  function initializeMainMenu() {
    const menuItemsHover = document.querySelectorAll('.as-menu-bar_item-with-overlay');
    const menuItemsClick = document.querySelectorAll('.as-menu-bar_button__button');
    const menuOverlays = document.querySelectorAll('.as-menu-bar_menu-overlay');
    const menuOverlayButtons = document.querySelectorAll('.as-menu-bar_button-overlay');
    const backDrop = document.querySelector('.as-menu-bar_overlay-backdrop');
    const mobileMenu = document.querySelector('.as-menu-bar_button-menu');
    const mobileMenuClose = document.querySelector('.as-menu-bar_button-close');
    const mobileOverlay = document.querySelector('.as-menu-bar__mobile-overlay');
    const mobileAccountOverlay = document.querySelector('.as-menu-bar_account-overlay');
    const mobileItemClick = document.querySelectorAll('.as-menu-bar_mobile-item-button');
    const mobileItemHover = document.querySelectorAll('.as-menu-bar_mobile-item-hover-button');
  
    function handleMenuItemHover(index) {
      for (var i = 0; i < menuOverlays.length; i++) {
        menuOverlays[i].classList.remove('as-menu-bar_overlay-visible');
      }
  
      for (var i = 0; i < menuOverlayButtons.length; i++) {
        menuOverlayButtons[i].classList.remove('as-menu-bar_overlay-visible');
      }
  
      menuOverlays[index].classList.add('as-menu-bar_overlay-visible');
      backDrop.classList.add('as-menu-bar_overlay-visible');
    }
  
    function handleMenuItemLeave(index) {
      menuOverlays[index].classList.remove('as-menu-bar_overlay-visible');
      backDrop.classList.remove('as-menu-bar_overlay-visible');
    }
  
    function handleMenuItemClick(index) {
        for (var i = 0; i < menuOverlayButtons.length; i++) {
          menuOverlayButtons[i].classList.remove('as-menu-bar_overlay-visible');
        }
  
      var isOpen = !!(menuOverlayButtons[index].classList.contains('as-menu-bar_overlay-visible'));
  
      menuOverlayButtons[index].classList.toggle('as-menu-bar_overlay-visible', !isOpen);
      backDrop.classList.toggle('as-menu-bar_overlay-visible', !isOpen);
    }
  
    function handleBackdropClick(index) {
        for (var i = 0; i < menuOverlayButtons.length; i++) {
          menuOverlayButtons[i].classList.remove('as-menu-bar_overlay-visible');
          mobileAccountOverlay.classList.remove('as-menu-bar_overlay-visible');
          mobileMenuClose.style.display = "none";
          mobileMenu.style.display = "inline-flex";
        }
      
      backDrop.classList.remove('as-menu-bar_overlay-visible');
      
    }
  
    function handleMobileMenuClick() {
      mobileOverlay.classList.add('as-menu-bar_overlay-visible');
      mobileMenuClose.style.display = "inline-flex";
      mobileMenu.style.display = "none";
    }
  
    function handleMobileMenuCloseClick() {
      mobileOverlay.classList.remove('as-menu-bar_overlay-visible');
      mobileAccountOverlay.classList.remove('as-menu-bar_overlay-visible');
      backDrop.classList.remove('as-menu-bar_overlay-visible');
      mobileMenuClose.style.display = "none";
      mobileMenu.style.display = "inline-flex";
    }
  
    for (let i = 0; i < menuItemsHover.length; i++) {
      menuItemsHover[i].addEventListener('mouseover', handleMenuItemHover.bind(null, i));
      menuOverlays[i].addEventListener('mouseleave', handleMenuItemLeave.bind(null, i));
    }
  
    for (let i = 0; i < menuItemsClick.length; i++) {
      menuItemsClick[i].addEventListener('click', (function(index) {
        return function(event) {          
          if (menuOverlayButtons[index]) {
            event.preventDefault();
            handleMenuItemClick(index);   
          }
          
        };
      })(i));
  
      backDrop.addEventListener('click', (function(index) {
       return function() {
          handleBackdropClick(index);
        };
      })(i));
    }
  
    for (let i = 0; i < mobileItemHover.length; i++) {
      mobileItemHover[i].addEventListener('click', (function(index) {
        return function(event) {
          event.preventDefault();
          handleMenuItemHover(index);
        };
      })(i));
  
      backDrop.addEventListener('click', (function(index) {
        return function() {
          handleBackdropClick(index);
        };
      })(i));
    }

    for (let i = 0; i < mobileItemClick.length; i++) {
      mobileItemClick[i].addEventListener('click', (function(index) {
        return function(event) {
          event.preventDefault();
          mobileOverlay.classList.remove('as-menu-bar_overlay-visible');
          handleMenuItemClick(index + 1);
        };
      })(i));
  
      backDrop.addEventListener('click', (function(index) {
        return function() {
          handleBackdropClick(index);
        };
      })(i));
    }
  
    mobileMenu.addEventListener('click', handleMobileMenuClick);
    mobileMenuClose.addEventListener('click', handleMobileMenuCloseClick);
  }
})();
